import {XMarkIcon} from '@heroicons/react/20/solid';
import classNames from 'classnames';
import React, {ReactElement, useCallback} from 'react';
import {DebounceInput, DebounceInputProps} from 'react-debounce-input';

import {SearchIcon} from '../../../resources/Icons';

type Props = Omit<DebounceInputProps<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>, 'onChange'> & {
  onChange: (value: string) => void;
  containerClassName?: string;
};

const SearchInput = ({onChange, containerClassName, className, ...rest}: Props): ReactElement => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  const handleClickClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <div className={classNames('group relative', containerClassName)}>
      <SearchIcon className="absolute top-[12px] left-[12px] w-[20px] h-[20px]" />
      <DebounceInput
        onChange={handleChange}
        className={classNames(
          'w-full text-left pl-[40px] text-sm',
          '[&:not([disabled]):not(.error):not(:invalid)]:group-hover:border-primary-300',
          className
        )}
        type="text"
        {...rest}
      />
      {rest.value && (
        <button type={'button'} className={'absolute top-[12px] right-[12px]'} onClick={handleClickClear}>
          <XMarkIcon width={20} height={20} className={'text-primary-800'} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
